// Funções puras da tela de clientes: espelhamento V1 » V2 por cliente.

export const INGEST_KEY_REGEX = /^vnx_live_[A-Za-z0-9_]{16,}$/;

export const MIRROR_HELP =
  'A alteração leva até 1 minuto para valer (cache do backend).';

export const isValidIngestKey = (key) =>
  typeof key === 'string' && INGEST_KEY_REGEX.test(key);

// Avisos (não bloqueiam) para combinações sem sentido. Retorna lista de textos.
export const getMirrorHints = (client) => {
  const orders = client?.v2_mirror_orders === true;
  const events = client?.v2_mirror_events === true;
  const keySet = client?.v2_ingest_key_set === true;
  const hints = [];

  if (events && !orders) {
    hints.push(
      'Ocorrências ligadas com Pedidos desligados: OK se o pedido nasce na V2 (ex.: cliente nativo V2); senão a V2 recebe eventos sem pedido.',
    );
  }
  if (orders && !events) {
    hints.push('Pedidos ligados com Ocorrências desligadas: a V2 verá o pedido nascer mas não receberá o andamento.');
  }
  if (orders && !keySet) {
    hints.push('Defina a chave de ingestão V2 ou o espelhamento não entrega.');
  }
  return hints;
};

// Aplica um patch imutável à linha do cliente `id`. Nunca copia a chave.
export const patchClient = (clients, id, patch) =>
  (clients || []).map((c) => {
    if (c.id !== id) return c;
    const { v2_ingest_key, ...safe } = patch || {};
    return { ...c, ...safe };
  });

// Corpo do PUT a partir de um patch de booleans e/ou chave.
export const buildUpdateBody = (id, { orders, events, key } = {}) => {
  const body = { id };
  if (typeof orders === 'boolean') body.v2_mirror_orders = orders;
  if (typeof events === 'boolean') body.v2_mirror_events = events;
  if (typeof key === 'string') body.v2_ingest_key = key;
  return body;
};
